import { createSelector } from 'reselect'
import { RootState } from '../../../store'

// Custom selector
const selectAuthenticationView = (state: RootState) => state.authenticationView

const selectUserEntities = (state: RootState) => state.userEntities.entities

export const selectCurrentUserId = (state: RootState) => selectAuthenticationView(state).userId

export const selectCurrentOrganizationId = (state: RootState) =>
  selectAuthenticationView(state).organizationId

export const selectCurrentUser = createSelector(
  selectUserEntities,
  selectCurrentUserId,
  (userEntities, userId) => (userId ? userEntities[userId] : undefined)
)

export const selectIsLoggedIn = (state: RootState) => selectAuthenticationView(state).isLoggedIn

/** True until boot-time silent refresh resolves. See apps/client AuthLayout. */
export const selectIsHydrating = (state: RootState) => selectAuthenticationView(state).isHydrating
